import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import {ValidatonError} from '../resources/GenericResource';

const ShiftPaymentFormModel = t.struct({
    payment: t.Str,
    paymentDescription: t.Str,
    chat: t.Bool
});

class FormLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {inputs, value} = this.props;
        return (
            <div className="finish-form-content">
                <div className="graybox checkboxes">
                    <label className="form-control form-control-checkbox">
                        {inputs.chat}
                        <span className="fake-checkbox"></span>
                        <div className="checkbox-description">
                            <h3 className="label-title">Enable chat</h3>
                            <p className="label-description">Allow candidates to contact you for additional questions.</p>
                        </div>
                    </label>
                </div>

                <div className="graybox payment">
                    <h3 className="label-title">How will you pay to your worker?</h3>
                    <p className="label-description">Choose the payment method you will use for paying the workers for their great job</p>

                    <div className="form-control form-control-select form-control-payment">
                        {inputs.payment}
                    </div>

                    <h3 className="label-title">When will the payment be delivered to the worker?</h3>
                    <p className="label-description">Shortly write when the workers should expect your payment - whether it will be right after the shift, within 7 days, or other reasonable period.</p>

                    <label className="form-control form-control-text form-control-textarea">
                        {inputs.paymentDescription}
                    </label>
                </div>

            </div>
        );
    }
}

function makeLayout(locals) {
    return <FormLayout {...locals}/>
}

const Form = baseFormFactory(ShiftPaymentFormModel, true, true);

class ShiftPaymentForm extends Form {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        const value = props.initialFormData;
        value.chat = (typeof value.chat === 'undefined') ? true : value.chat;
        value.payment = value.payment || {};
        value.paymentDescription = value.paymentDescription || '';
        this.state = {
            isValid,
            value,
            disabled: props.disabled
        };
    }

    buildSelectOptions(payments) {
        // [{value: 'x', text: 'y'}, ...]
        return payments.map(pmnt => {
            return {value: pmnt.id, text: pmnt.method};
        });

    }

    getOptions() {
        const errors = this.props.errors;
        return {
            auto: 'none',

            template: makeLayout,

            fields: {
                payment: {
                    nullOption: {value: '', text: 'Choose a payment method'},
                    options: this.buildSelectOptions(this.props.payments),
                    factory: t.form.Select,
                    attrs: {
                        className: "form-control form-control-select"
                    },
                    hasError: !!errors,
                    error: errors && errors['payment'] ? "Select a payment method" : null,
                    disabled: this.state.disabled
                },

                paymentDescription: {
                    type: 'textarea',
                    hasError: !!errors,
                    error: errors && errors['paymentDescription'] ? "Write a short description" : null,
                    disabled: this.state.disabled
                },

                chat: {
                    template: (locals) => {
                        return (
                            <input disabled={this.state.disabled} type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} />
                        );
                    }
                }
            }
        };
    }

    onChange(value) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
        super.onChange(value);
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

ShiftPaymentForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired,
    payments: React.PropTypes.array.isRequired,
    onChange: React.PropTypes.func
};


export default ShiftPaymentForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/ShiftPaymentForm.js
 **/